import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WysiwygEditorComponent } from './wysiwyg-editor.component';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [WysiwygEditorComponent],
  exports: [WysiwygEditorComponent],
  imports: [CommonModule, CKEditorModule, FormsModule],
})
export class WysiwygEditorModule {}
